import React, { Component } from 'react';
import { MAP_STYLE, getRiderSVG } from './order-track-constants';
import { createHomeLabelOverlay } from '../../../widgets/OrderTracker/organism/atoms/Map/utils';

var curvature = 0.5;
export default class CrystalMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpired: false,
      isOnFullscreen: false,
    };
    this.map = null;
    this.mapID = 'crystalMap';
    this.mapStyle = MAP_STYLE;
    this.bounds = new window.google.maps.LatLngBounds();
    this.curveMarker = null;
    this.timerID1 = null;
    this.timerID2 = null;
    this.resetZoomTimerID = null;
    this.polylinePath = null;
    this.curvePolylinePath = null;
    this.markers = {
      source: null,
      destination: null,
      rider: null,
      curveMarker: null,
    };
    this.rotationAngle = 0;
    this.offsetPx = 16;
    this.riderWidth = 55;
    this.riderHeight = 55;
    this.animateRiderProps = {
      numDeltas: 500,
      delay: 10,
      i: 0,
      startLat: null,
      startLng: null,
      deltaLat: null,
      deltaLng: null,
    };
  }

  componentDidMount = () => {
    this.renderMap();
  };

  componentDidUpdate = () => {
    this.updateMap();
  };

  componentWillUnmount = () => {
    clearTimeout(this.timerID1);
    clearTimeout(this.timerID2);
  };

  animate = () => {
    const { google } = window;
    let targetLat =
      this.animateRiderProps.startLat + this.animateRiderProps.deltaLat;
    let targetLng =
      this.animateRiderProps.startLng + this.animateRiderProps.deltaLng;
    let latlng = new google.maps.LatLng(targetLat, targetLng);
    this.markers.rider.setPosition(latlng);
    this.animateRiderProps.startLat = targetLat;
    this.animateRiderProps.startLng = targetLng;
    if (this.animateRiderProps.i != this.animateRiderProps.numDeltas) {
      this.animateRiderProps.i += 1;
      setTimeout(this.animate, this.animateRiderProps.delay);
    }
  };

  moveRider = (markerInfo) => {
    this.animateRiderProps.i = 0;
    this.animateRiderProps.startLat = this.markers.rider.getPosition().lat();
    this.animateRiderProps.startLng = this.markers.rider.getPosition().lng();
    this.animateRiderProps.deltaLat =
      (markerInfo.latitude - this.animateRiderProps.startLat) /
      this.animateRiderProps.numDeltas;
    this.animateRiderProps.deltaLng =
      (markerInfo.longitude - this.animateRiderProps.startLng) /
      this.animateRiderProps.numDeltas;
    this.animate();
  };

  renderMarker = (markerInfo, map) => {
    const { orderBasicInfo } = this.props;

    const NDPODetails =
      orderBasicInfo?.order?.no_delivery_pin_address_details || {};

    const { google } = window;
    let options = {
      map,
      position: {
        lat: parseFloat(markerInfo.latitude),
        lng: parseFloat(markerInfo.longitude),
      },
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 0,
      },
    };
    // Reuse existing marker to avoid stacking instances across refreshes
    let marker = this.markers[markerInfo?.type];
    if (marker) {
      marker.setOptions(options);
    } else {
      marker = new google.maps.Marker(options);
    }
    if (markerInfo?.type === 'rider') {
      if (!this.markers.rider) {
        marker.setZIndex(100);
        marker.setIcon({
          url:
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(
              getRiderSVG({ rotationAngle: this.rotationAngle }),
            ),
          scaledSize: new google.maps.Size(
            75 - this.offsetPx,
            75 - this.offsetPx,
          ),
          anchor: new google.maps.Point(
            this.riderWidth / 2,
            this.riderHeight / 2,
          ),
        });
      }
    } else {
      let imageSrc = markerInfo.icon.url;
      const modifiedImage = new Image();
      modifiedImage.src = imageSrc;
      modifiedImage.onload = () => {
        const originalWidth = modifiedImage.width;
        const originalHeight = modifiedImage.height;
        const aspectRatio = originalHeight / originalWidth;

        const scaledWidth = markerInfo.icon.width - this.offsetPx;
        const scaledHeight = scaledWidth * aspectRatio;

        marker.setIcon({
          url: imageSrc,
          scaledSize: new google.maps.Size(scaledWidth, scaledHeight),
        });
      };
    }
    this.markers[markerInfo?.type] = marker;

    if (!markerInfo?.should_exclude_in_zoom)
      this.bounds.extend(marker.getPosition());

    // Draw circle around destination (customer). Clear previous circle/overlay to prevent stacking on refresh
    if (markerInfo?.type === 'destination' && NDPODetails?.show_marker) {
      if (marker._circle) {
        marker._circle.setMap(null);
      }
      const circle = new google.maps.Circle({
        radius: NDPODetails.polygon_details?.radius || 200,
        map: map,
        strokeColor: NDPODetails.polygon_details?.color || '#4285F4',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        fillColor: NDPODetails.polygon_details?.color || '#4285F4',
        fillOpacity: 0.1,
      });
      circle.bindTo('center', marker, 'position');
      marker._circle = circle;

      if (marker._homeLabel) {
        marker._homeLabel.setMap(null);
      }
      let homeLabelDiv = createHomeLabelOverlay(
        { latitude: markerInfo.latitude, longitude: markerInfo.longitude },
        map,
      );
      marker._homeLabel = homeLabelDiv;

      marker.addListener('position_changed', () => {
        if (homeLabelDiv) {
          homeLabelDiv.position = {
            latitude: marker.getPosition().lat(),
            longitude: marker.getPosition().lng(),
          };
          homeLabelDiv.draw();
        }
      });
    }
  };

  smoothZoom = (map, max, cnt) => {
    const { google } = window;
    if (cnt >= max) {
      return;
    } else {
      let z = google.maps.event.addListener(map, 'zoom_changed', () => {
        google.maps.event.removeListener(z);
        this.smoothZoom(map, max, cnt + 1);
      });
      this.timerID1 = setTimeout(function () {
        map.setZoom(cnt);
      }, 80);
    }
  };

  getLatLngs = (markers) => {
    let marker = {};
    for (let i = 0; i < markers.length; i++) {
      marker[markers[i]?.type] = {
        lat: parseFloat(markers[i].latitude),
        lng: parseFloat(markers[i].longitude),
      };
    }
    return marker;
  };

  getCenter = (markers) => {
    let source;
    let destination;
    for (let i = 0; i < markers.length; i++) {
      if (markers[i]?.type === 'source') {
        source = markers[i];
      } else if (markers[i]?.type === 'destination') {
        destination = markers[i];
      }
    }
    const centerLat = (source.latitude + destination.latitude) / 2;
    const centerLng = (source.longitude + destination.longitude) / 2;
    return { lat: centerLat, lng: centerLng };
  };

  decodeLevels = (encodedLevelsString) => {
    var decodedLevels = [];
    for (var i = 0; i < encodedLevelsString.length; ++i) {
      var level = encodedLevelsString.charCodeAt(i) - 63;
      decodedLevels.push(level);
    }
    return decodedLevels;
  };

  updateMarkerRotation = (google, polylinePath) => {
    const path = polylinePath.getPath();
    if (path.getLength() >= 2) {
      const heading = google.maps.geometry.spherical.computeHeading(
        path.getAt(0),
        path.getAt(1),
      );
      this.rotationAngle = heading;
    }
  };

  drawPolyline = (google, map, path) => {
    if (!path) return;
    var decodedPath = google.maps.geometry.encoding.decodePath(path.polyline);
    var decodedLevels = this.decodeLevels('BBBBB');

    const polylinePath = new google.maps.Polyline({
      path: decodedPath,
      levels: decodedLevels,
      strokeColor: '#4990E2',
      strokeOpacity: 1.0,
      strokeWeight: 3,
      fillColor: '#8A8A1D',
      fillOpacity: 0,
      map: map,
    });
    polylinePath.setMap(map);
    this.updateMarkerRotation(google, polylinePath);
    this.polylinePath = polylinePath;

    if (!path.should_exclude_in_zoom) {
      decodedPath.forEach((LatLng) => {
        this.bounds.extend(LatLng);
      });
    }
  };

  drawCurve = (markers, map) => {
    const { google } = window;
    const lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 0.3,
      scale: 3,
    };

    const curvePolylinePath = new google.maps.Polyline({
      path: [markers.destination, markers.source],
      icons: [
        {
          icon: lineSymbol,
          offset: '0',
          repeat: '15px',
        },
      ],
      strokeColor: '#000',
      strokeOpacity: 0,
      map: map,
    });
    curvePolylinePath.setMap(map);
    this.curvePolylinePath = curvePolylinePath;
  };

  updateCurveMarker = (allLatLngs, map) => {
    if (allLatLngs && map) {
      const { google } = window;
      let LatLng = google.maps.LatLng,
        Marker = google.maps.Marker,
        Point = google.maps.Point,
        pos1 = new LatLng(allLatLngs.source.lat, allLatLngs.source.lng),
        pos2 = new LatLng(
          allLatLngs.destination.lat,
          allLatLngs.destination.lng,
        ),
        projection = map.getProjection(),
        p1 = projection?.fromLatLngToPoint(pos1),
        p2 = projection?.fromLatLngToPoint(pos2);

      let e = new Point(p2.x - p1.x, p2.y - p1.y), // endpoint (p2 relative to p1)
        m = new Point(e.x / 2, e.y / 2), // midpoint
        o = new Point(e.y, -e.x), // orthogonal
        c = new Point(m.x + curvature * o.x, m.y + curvature * o.y); // curve control point

      let pathDef = `M 0,0 q ${c.x},${c.y} ${e.x} ,${e.y}`;

      let zoom = map.getZoom(),
        scale = 1 / Math.pow(2, -zoom);

      let symbol = {
        path: pathDef,
        scale: scale,
        strokeWeight: 2,
        fillColor: 'none',
      };

      if (!this.curveMarker) {
        this.curveMarker = new Marker({
          position: pos1,
          clickable: false,
          icon: symbol,
          zIndex: 0, // behind the other markers
          map: map,
        });
        this.markers.curveMarker = this.curveMarker;
      } else {
        this.curveMarker.setOptions({
          position: pos1,
          icon: symbol,
        });
      }
    }
  };

  renderCircle = (destinationMarker, map) => {
    const { google } = window;
    const circle = new google.maps.Circle({
      strokeColor: '#3AB757',
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillColor: '#EBFFEF',
      fillOpacity: 0.15,
      map: map,
      center: {
        lat: destinationMarker.latitude,
        lng: destinationMarker.longitude,
      },
      radius: destinationMarker.circle.radius,
    });
    circle.setMap(map);
  };

  updateMarkers = (updatedMarkers, paths, map) => {
    if (!Array.isArray(updatedMarkers) || !updatedMarkers.length) return;
    if (!Array.isArray(paths) || !paths.length) return;

    const { google } = window;
    // clear the curve marker
    if (paths[0]?.type === 'solid' && !this.markers.rider) {
      this.markers.curveMarker?.setMap(null);
      this.markers.curveMarker = null;
    }
    // update the markers
    for (let i = 0; i < updatedMarkers.length; i++) {
      if (!updatedMarkers[i] || !updatedMarkers[i]?.type) continue;
      this.renderMarker(updatedMarkers[i], map);
      if (updatedMarkers[i]?.type === 'rider') {
        this.moveRider(updatedMarkers[i]);
        this.markers.rider.setIcon({
          url:
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(
              getRiderSVG({ rotationAngle: this.rotationAngle }),
            ),
          scaledSize: new google.maps.Size(
            75 - this.offsetPx,
            75 - this.offsetPx,
          ),
          anchor: new google.maps.Point(
            this.riderWidth / 2,
            this.riderHeight / 2,
          ),
        });
        if (!updatedMarkers[i].should_exclude_in_zoom)
          this.bounds.extend(this.markers.rider.getPosition());
      }
    }
  };

  updatePolyline = (google, map, paths, allLatLngs) => {
    if (this.polylinePath) this.polylinePath.setMap(null);
    if (this.curvePolylinePath) this.curvePolylinePath.setMap(null);
    if (paths && paths.length) {
      if (paths[0]?.type === 'solid') {
        this.drawPolyline(google, map, paths[0]);
      } else if (paths[0]?.type === 'aerial') {
        this.drawCurve(allLatLngs, map);
        google.maps.event.addListener(
          map,
          'projection_changed',
          this.updateCurveMarker.bind(this, allLatLngs, map),
        );
        google.maps.event.addListener(
          map,
          'zoom_changed',
          this.updateCurveMarker.bind(this, allLatLngs, map),
        );
      }
    }
  };

  updateMap = () => {
    const mapData = this.props;
    if (!mapData) return null;
    const { google } = window;
    const { markers, paths } = mapData;

    if (!markers?.length || !paths?.length || !google || !this.map) return;

    let allLatLngs = this.getLatLngs(markers);
    if (this.map) {
      this.bounds = new google.maps.LatLngBounds();
      this.updatePolyline(google, this.map, paths, allLatLngs);
      this.updateMarkers(markers, paths, this.map);
      this.map.fitBounds(this.bounds);
    }
  };

  renderMap = () => {
    const mapData = this.props;
    if (!mapData) return null;
    const { markers, paths } = mapData;
    if (!markers || !markers?.length || !paths || !paths?.length) return null;
    const { google } = window;
    const mapEle = document.getElementById(this.mapID);

    let allLatLngs = this.getLatLngs(markers);
    let center = this.getCenter(markers);
    let map =
      mapEle &&
      new google.maps.Map(document.getElementById(this.mapID), {
        center,
        zoom: 14,
        minZoom: 10,
        disableDefaultUI: true,
        mapTypeControl: false,
        styles: this.mapStyle,
        fullscreenControl: false,
        gestureHandling: 'greedy',
        keyboardShortcuts: false,
        panControl: true,
        clickableLabels: false,
      });
    if (paths && paths.length) {
      if (paths[0]?.type === 'solid') {
        this.drawPolyline(google, map, paths[0]);
      } else if (paths[0]?.type === 'aerial') {
        this.drawCurve(allLatLngs, map);
        google.maps.event.addListener(
          map,
          'projection_changed',
          this.updateCurveMarker.bind(this, allLatLngs, map),
        );
      }
    }
    for (let i = 0; i < markers.length; i++) {
      this.renderMarker(markers[i], map);
    }

    google.maps.event.addListener(map, 'zoom_changed', () => {
      if (this.resetZoomTimerID) {
        clearTimeout(this.resetZoomTimerID);
        this.resetZoomTimerID = setTimeout(() => {
          map.fitBounds(this.bounds);
          let maxZoomLevel = 15;
          let newZoom = Math.min(map.getZoom(), maxZoomLevel);
          map.setZoom(newZoom);
        }, 5000);
      }
      if (this.markers.curveMarker) this.updateCurveMarker(allLatLngs, map);
    });
    map.fitBounds(this.bounds);
    this.map = map;
  };

  render() {
    const mapData = this.props;
    if (!mapData) return null;
    return (
      <React.Fragment>
        <div
          data-dd-privacy='mask'
          style={{ width: '100%', height: '350px' }}
          id={this.mapID}
        ></div>
      </React.Fragment>
    );
  }
}
